import { getCookie, setCookie } from "@/service/cookie";

export const setAsDisplayed = (name, untilInSeconds) => {
    setCookie(name, true, untilInSeconds)
}

export const getIsDisplayed = (name) => {
    return !! getCookie(name)
}